<template>
  <div class="flex flex-col gap-5">
    <Typography
      v-if="title && title.trim()"
      as="h2"
      variant="body-medium"
      class="font-bold text-sm"
    >
      {{ title }}
    </Typography>
    <ul
      class="flex flex-col gap-5 text-sm"
      :class="{ 'grid grid-cols-2 md:grid-cols-1': mobileTwoColumns }"
    >
      <li v-for="(link, index) in links" :key="link.title ?? `linklist-${index}`">
        <Link
          :to="link.url ?? ''"
          variant="footer-linklist"
          :class="{ 'font-bold': isBoldLink(link) && link.bold }">
          {{ link.title }}
        </Link>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { BoldLinkApiModel } from '@gro-up/api/corporate'
import type { Link as LinkType } from '@gro-up/types'
import { Link, Typography } from '@gro-up/ui/primitives'

function isBoldLink(link: LinkType | BoldLinkApiModel): link is BoldLinkApiModel {
  return 'bold' in link
}

defineProps<{
  title: string
  links: LinkType[] | BoldLinkApiModel[]
  mobileTwoColumns?: boolean
}>()
</script>

